import { NavLink, PageHeader } from '@frontendmentorio/design-system-v2';

import Layout from 'features/shared/Layout';
import Comments from 'features/learners/profile/Comments';

export default function Page({ user }) {
  return (
    <Layout
      description={`${user.username}'s comments page on Frontend Mentor. View ${user.username}'s code reviews and feedback here.`}
      image={user?.avatar}
      title={`Frontend Mentor | ${user?.displayName}'s profile`}
      url={`https://www.frontendmentor.io/profile/${user?.username}`}
    >
      <PageHeader heading="Profile" isSticky>
        <PageHeader.NavLinks>
          <NavLink href={`/profile/${user.username}`} level="secondary">
            Overview
          </NavLink>

          <NavLink
            count={user.solutionCount}
            href={`/profile/${user.username}/solutions`}
            level="secondary"
          >
            Solutions
          </NavLink>

          <NavLink
            count={user.commentCount}
            href={`/profile/${user.username}/comments`}
            isUnderline
            level="secondary"
          >
            Comments
          </NavLink>
        </PageHeader.NavLinks>
      </PageHeader>

      <Comments user={user} />
    </Layout>
  );
}

export async function getServerSideProps({ params }) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/learners/${params.username}`
  );

  if (!response.ok) return { notFound: true };

  const body = await response.json();

  return { props: { user: body.data } };
}
